//
import { LAYERS, normalizeAttributes } from 'app/utils/maps/layer/layerUtils';
import { calculateLayerZIndex } from 'app/config/layerZIndexConfig';
import { drawWMSLayer } from 'app/components/molecules/Map/DrawShapes/DrawWMSLayer';
import { drawXYZLayer } from 'app/components/molecules/Map/DrawShapes/xyzLayerUtlis';
import cesiumLayerConfig from 'app/config/cesiumLayerConfig';

export const createShapes = (layers, map, allClasses, allEventTypes) => {

    const layersGroup = map.getLayersGroup('allLayers');
   
    if (layersGroup) {
        const currentLayers = layersGroup ? layersGroup.getLayers().getArray() : [];
        const startingLayerCount = currentLayers.length;
        const totalLayers = layers?.length || 0;
        
        layers?.length && layers.forEach(async (layer, index) => {
            const effectivePosition = startingLayerCount + (totalLayers - index - 1);
            
            const { attributes, primary, type, classes, ...rest } = layer || {};
            const layerType = layer?.type;
            const normalizedAttributes = normalizeAttributes(classes, attributes) || {};
            const _attributes = { ...normalizedAttributes, ...rest };
            
            const zIndex = calculateLayerZIndex(effectivePosition);

            let layerToAdd = null;

            const cesiumLayer = [cesiumLayerConfig?.cesiumLayer?.oldType, cesiumLayerConfig?.cesiumLayer?.type];
            
            if (layerType === LAYERS.wms) {
                const layer = primary?.['layer'];
                const layer_url = primary?.['layer_url'];
                layerToAdd = drawWMSLayer({ layer, layer_url, _attributes: { ..._attributes, zIndex }, primary });
            } else if (layerType === LAYERS.xyz) {
                layerToAdd = drawXYZLayer({ _attributes: { ..._attributes, zIndex } });
            } else if (layerType === LAYERS.drawing) {
                map.addEntityLayer({ ..._attributes, type: 'drawing-layer', primary, styles: { pinStyle: 'drawing' }, zIndex });
            } else if (layerType === LAYERS.replay) {
                map.addEntityLayer({ ..._attributes, type: 'replay-layer', primary, styles: { pinStyle: 'replay' }, zIndex });
            } else if (layerType === LAYERS.entity || layerType === LAYERS.entityLayer) {
                const layerClass = layer?.entity_type;
                const styleType = layerType?.styles?.pinStyle || 'cluster';
                const classData = allClasses?.length && (allClasses.find(cls => cls.uri === layerClass?.uri) || layerClass);

                await map.addEntityLayer({
                    ..._attributes,
                    type: layerClass?.uri,
                    styleType,
                    primary,
                    zIndex, 
                    entityType: layerType,
                    layerTitle: 'Entity Layer',
                    classData
                });

            } else if (layerType === LAYERS.event) {
                const styleType = layerType?.styles?.pinStyle || 'cluster';
                const eventTypeData = allEventTypes?.find(et => et?.id === layer?.event_type?.id);
                map.addEntityLayer({ ..._attributes, type: LAYERS.event, styleType, primary, entityType: layerType, layerTitle: 'Event Layer', eventTypeData, zIndex });
            } else if (cesiumLayer.includes(layerType)) {
                map.addEntityLayer({
                    ..._attributes,
                    type: cesiumLayerConfig?.type,
                    primary,
                    styles: { pinStyle: layerType },
                    entityType: layerType,
                    type: layerType,
                    layerTitle: 'Cesium Ion Layer',
                    zIndex
                });
            }
            
            if (layerToAdd) {
                layersGroup.getLayers().array_.unshift(layerToAdd);
            }
        });
    }
};